


















































import ResponsiveImage from '@/components/common/Image.vue';
import CreateBlogPost from '@/graphql/mutations/createBlogPost.gql';
import BlogPostQuery from '@/graphql/queries/blogPosts.gql';
import request from '@/graphql/request';
import Vue from 'vue';
import Component from 'vue-class-component';

interface IPost {
  id: string;
  name: string;
  author: string;
  summary?: string;
  createdAt: Date;
  updatedAt: Date;
  published: boolean;
  thumbnail?: {
    url: string;
  };
}

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class Blog extends Vue {
  public posts: IPost[] = [];
  public isAdmin = false;
  public userId: string | null = null;

  public mounted() {
    request(BlogPostQuery)
      .then(response => {
        if (!response || !response.data) {
          console.error('No posts returned');
          return;
        }

        this.posts = response.data.blogPosts;
        this.isAdmin =
          response.data.user && response.data.user.role === 'admin';
        this.userId = response.data.user && response.data.user.id;

        this.posts.sort(
          (a, b) => +new Date(b.createdAt) - +new Date(a.createdAt)
        );
      })
      .catch(console.error);
  }

  public createNewPost() {
    request(CreateBlogPost, {
      input: JSON.stringify({ name: 'Draft', userId: this.userId }),
    }).then(response => {
      console.dir(response);
      if (response.errors || !response.data) {
        throw response.errors || 'An unkown error has occurred';
      }
      this.$router.push({
        path: `/blog/${response.data.createBlogPost.id}`,
        query: { editing: 'true' },
      });
    });
  }

  public formatDate(date: Date | string) {
    return new Date(date).toLocaleDateString(undefined, {
      day: '2-digit',
      year: 'numeric',
      month: 'long',
    });
  }

  public backgroundColor(id: string) {
    const seed = id.substr(id.lastIndexOf('-') + 1);
    const color = (n: number) => parseInt(seed.substr(n, 2), 16);
    const darken = (n: number) =>
      ((c: number) => (c - 60 >= 0 ? c - 60 : c))(color(n));

    return `linear-gradient(to bottom, rgb(${color(0)}, ${color(2)}, ${color(
      4
    )}), rgb(${darken(0)}, ${darken(2)}, ${darken(4)})`;
  }
}
